import { database } from "configs/firebaseConfigs";
import { update, ref, set, remove, push } from "firebase/database";

const updateDb = async (path, data) => {
  try {
    await update(ref(database, path), data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const setData = async (path, data) => {
  try {
    await set(ref(database, path), data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const delateData = async (path) => {
  try {
    await remove(ref(database, path));
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const pushData = async (path, data) => {
  try {
    let pushId = await push(ref(database, path), data);
    return pushId;
  } catch (error) {
    console.log(error);

    return false;
  }
};

const db = {
  updateDb,
  setData,
  delateData,
  pushData,
};

export default db;
